import {
  HoldPhoneIcon,
  InstagramIcon,
  Linkedin01Icon,
  Mail01Icon,
  NewTwitterIcon,
  WhatsappIcon,
} from "@hugeicons/core-free-icons";
import { FooterLinkGroup, SiteLink } from "./types/links";

export const navLinks: SiteLink[] = [
  { label: "Projects", href: "/#projects" },
  { label: "Services", href: "/#services" },
  { label: "Reviews", href: "/#reviews" },
  { label: "Contact", href: "/#contact" },
];

export const contactLinks: SiteLink[] = [
  { label: "WhatsApp", href: "https://wa.me/447754073228", icon: WhatsappIcon },
  { label: "Phone", href: "tel:+447754073228", icon: HoldPhoneIcon },
  {
    label: "Email",
    href: "mailto:jonathankoziel1@gmail.com",
    icon: Mail01Icon,
  },
];

export const socialLinks: SiteLink[] = [
  {
    label: "Instagram",
    href: "https://www.instagram.com/y0nat4n_/",
    icon: InstagramIcon,
  },
  {
    label: "X",
    href: "https://x.com/Yonat4nKoziel",
    icon: NewTwitterIcon,
  },
  {
    label: "LinkedIn",
    href: "https://www.linkedin.com/in/jonathankoziel/",
    icon: Linkedin01Icon,
  },
];

export const footerLinkGroups: FooterLinkGroup[] = [
  {
    heading: "Main",
    links: [{ label: "Home", href: "/" }, ...navLinks],
  },
  {
    heading: "Legal",
    links: [
      { label: "Privacy Policy", href: "/privacy" },
      { label: "Terms of Use", href: "/terms" },
    ],
  },
];
